'use client';

import React, { useState, useMemo } from 'react';
import { MediaProps } from './types';
import CardWrapperGrid from '../cards-wrapper-grid/CardsWrapperGrid';
import { CardProps } from '@/components/card/types';
import DownloadSection from '../download-section/DownloadSection';

const logoCards: (CardProps & { category?: string | string[] })[] = [
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh_official/Full Logo/Blue/Default/Full Logo - Default - White.png',
    alt: 'SMZH Logo - Blue',
    title: 'SMZH Logo - Blue',
    downloadLinks: {
      // ✅ New
      eps: '/de/media/smzh_official/Full Logo/Blue/Default/Full Logo - Default - White.eps',
      svg: '/de/media/smzh_official/Full Logo/Blue/Default/Full Logo - Default - White.svg',
      png: '/de/media/smzh_official/Full Logo/Blue/Default/Full Logo - Default - White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh_official/Full Logo/Blue/Website/Full Logo - Website - Blue.png',
    alt: 'SMZH Logo - Website - Blue',
    title: 'SMZH Logo - Website - Blue',
    downloadLinks: {
      eps: '/de/media/smzh_official/Full Logo/Blue/Website/Full Logo - Website - Blue.eps',
      svg: '/de/media/smzh_official/Full Logo/Blue/Website/Full Logo - Website - Blue.svg',
      png: '/de/media/smzh_official/Full Logo/Blue/Website/Full Logo - Website - Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh_official/Full Logo/Blue/Location/Full-Logo---Location---Blue.png',
    alt: 'SMZH Logo - Locations - Blue',
    title: 'SMZH Logo - Locations - Blue',
    downloadLinks: {
      eps: '/de/media/smzh_official/Full Logo/Blue/Website/Full Logo - Website - Blue.eps',
      svg: '/de/media/smzh_official/Full Logo/Blue/Website/Full Logo - Website - Blue.svg',
      png: '/de/media/smzh_official/Full Logo/Blue/Location/Full-Logo---Location---Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh_official/Full Logo/White/Default/Full Logo - Default - White.png',
    alt: 'SMZH Logo - White',
    title: 'SMZH Logo - White',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh_official/Full Logo/White/Default/Full Logo - Default - White.eps',
      svg: '/de/media/smzh_official/Full Logo/White/Default/Full Logo - Default - White.svg',
      png: '/de/media/smzh_official/Full Logo/White/Default/Full Logo - Default - White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh_official/Full Logo/White/Website/Full Logo - Website - White.png',
    alt: 'SMZH Logo - Website - White',
    title: 'SMZH Logo - Website - White',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh_official/Full Logo/White/Website/Full Logo - Website - White.eps',
      svg: '/de/media/smzh_official/Full Logo/White/Website/Full Logo - Website - White.svg',
      png: '/de/media/smzh_official/Full Logo/White/Website/Full Logo - Website - White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh_official/Full Logo/White/Location/Full-Logo---Location---White.png',
    alt: 'SMZH Logo - Locations - White',
    title: 'SMZH Logo - Locations - White',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh_official/Full Logo/Blue/Website/Full Logo - Website - Blue.eps',
      svg: '/de/media/smzh_official/Full Logo/White/Location/Full Logo - Location - White.svg',
      png: '/de/media/smzh_official/Full Logo/White/Location/Full-Logo---Location---White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh_official/Icon/Blue/Icon - Blue.png',
    alt: 'SMZH Icon - Blue',
    title: 'SMZH Icon - Blue',
    category: 'square',
    downloadLinks: {
      eps: '/de/media/smzh_official/Icon/Blue/Icon - Blue.eps',
      svg: '/de/media/smzh_official/Icon/Blue/Icon - Blue.svg',
      png: '/de/media/smzh_official/Icon/Blue/Icon - Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh_official/Icon/White/Icon - White.png',
    alt: 'SMZH Icon - White',
    title: 'SMZH Icon - White',
    category: ['darkBg', 'square'],
    downloadLinks: {
      eps: '/de/media/smzh_official/Icon/White/Icon - White.eps',
      svg: '/de/media/smzh_official/Icon/White/Icon - White.svg',
      png: '/de/media/smzh_official/Icon/White/Icon - White.png',
    },
  },
];

const badgeCards: (CardProps & { downloadLinks?: any })[] = [
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh_official/Badges/Default/Logo Badge/Blue/Logo Badge - Blue.png',
    alt: 'Badge SMZH',
    title: 'Badge SMZH',
    downloadLinks: {
      eps: '/de/media/smzh_official/Badges/Default/Logo Badge/Blue/Logo Badge - Blue.eps',
      svg: '/de/media/smzh_official/Badges/Default/Logo Badge/Blue/Logo Badge - Blue.svg',
      png: '/de/media/smzh_official/Badges/Default/Logo Badge/Blue/Logo Badge - Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh_official/Badges/Location/Blue/Logo-Badge---Location---Blue.png',
    alt: 'Badge SMZH Location',
    title: 'Badge SMZH Location',
    downloadLinks: {
      eps: '/de/media/smzh_official/Badges/Location/Blue/Logo-Badge---Location---Blue.eps',
      svg: '/de/media/smzh_official/Badges/Location/Blue/Logo-Badge---Location---Blue.svg',
      png: '/de/media/smzh_official/Badges/Location/Blue/Logo-Badge---Location---Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh_official/Badges/Website/Blue/Logo Badge - Website - Blue.png',
    alt: 'Badge SMZH Website',
    title: 'Badge SMZH Website',
    downloadLinks: {
      eps: '/de/media/smzh_official/Badges/Website/Blue/Logo Badge - Website - Blue.eps',
      svg: '/de/media/smzh_official/Badges/Website/Blue/Logo Badge - Website - Blue.svg',
      png: '/de/media/smzh_official/Badges/Website/Blue/Logo Badge - Website - Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh_official/Badges/Default/Logo Badge/White/Logo Badge - White.png',
    alt: 'Badge SMZH White',
    title: 'Badge Two',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh_official/Badges/Default/Logo Badge/White/Logo Badge - White.eps',
      svg: '/de/media/smzh_official/Badges/Default/Logo Badge/White/Logo Badge - White.svg',
      png: '/de/media/smzh_official/Badges/Default/Logo Badge/White/Logo Badge - White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh_official/Badges/Location/White/Logo-Badge---Location---White.png',
    alt: 'Badge SMZH White Locations',
    title: 'Badge SMZH White Locations',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh_official/Badges/Location/White/Logo-Badge---Location---White.eps',
      svg: '/de/media/smzh_official/Badges/Location/White/Logo-Badge---Location---White.svg',
      png: '/de/media/smzh_official/Badges/Location/White/Logo-Badge---Location---White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh_official/Badges/Website/White/Logo Badge - Website - White.png',
    alt: 'Badge SMZH White Website',
    title: 'Badge SMZH White Website',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh_official/Badges/Website/White/Logo Badge - Website - White.eps',
      svg: '/de/media/smzh_official/Badges/Website/White/Logo Badge - Website - White.svg',
      png: '/de/media/smzh_official/Badges/Website/White/Logo Badge - Website - White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh_official/Icon/Blue/Icon - Blue.png',
    alt: 'Icon Badge Blue',
    title: 'Icon Badge Blue',
    category: 'square',
    downloadLinks: {
      eps: '/de/media/smzh_official/Icon/Blue/Icon - Blue.eps',
      svg: '/de/media/smzh_official/Icon/Blue/Icon - Blue.svg',
      png: '/de/media/smzh_official/Icon/Blue/Icon - Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh_official/Icon/White/Icon - White.png',
    alt: 'Icon Badge White',
    title: 'Icon Badge White',
    category: ['darkBg', 'square'],
    downloadLinks: {
      eps: '/de/media/smzh_official/Icon/White/Icon - White.eps',
      svg: '/de/media/smzh_official/Icon/White/Icon - White.svg',
      png: '/de/media/smzh_official/Icon/White/Icon - White.png',
    },
  },
];

const locationCards: (CardProps & { city: string; downloadLinks?: any })[] = [
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-aarau/Icon/Blue/Icon - Aarau - Blue.png',
    alt: 'SMZH Icon -  Aarau - Blue',
    title: 'SMZH Icon -  Aarau - Blue',
    city: 'aarau',
    category: 'square',
    downloadLinks: {
      eps: '/de/media/smzh-aarau/Icon/Blue/Icon - Aarau - Blue.eps',
      svg: '/de/media/smzh-aarau/Icon/Blue/Icon - Aarau - Blue.svg',
      png: '/de/media/smzh-aarau/Icon/Blue/Icon - Aarau - Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-aarau/Full Logo/Blue/Full Logo - Aarau - Blue.png',
    alt: 'SMZH Logo -  Aarau - Blue',
    title: 'SMZH Logo -  Aarau - Blue',
    city: 'aarau',
    downloadLinks: {
      eps: '/de/media/smzh-aarau/Full Logo/Blue/Full Logo - Aarau - Blue.eps',
      svg: '/de/media/smzh-aarau/Full Logo/Blue/Full Logo - Aarau - Blue.svg',
      png: '/de/media/smzh-aarau/Full Logo/Blue/Full Logo - Aarau - Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-aarau/Badges/Logo Badge/Blue/Logo-Badge---Aarau---Blue.png',
    alt: 'SMZH Logo -  Aarau - Blue',
    title: 'SMZH Logo -  Aarau - Blue',
    city: 'aarau',
    downloadLinks: {
      eps: '/de/media/smzh-aarau/Badges/Logo Badge/Blue/Logo-Badge---Aarau---Blue.eps',
      svg: '/de/media/smzh-aarau/Badges/Logo Badge/Blue/Logo-Badge---Aarau---Blue.svg',
      png: '/de/media/smzh-aarau/Badges/Logo Badge/Blue/Logo-Badge---Aarau---Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-aarau/Icon/White/Icon - Aarau - White.png',
    alt: 'SMZH Icon -  Aarau - White',
    title: 'SMZH Icon -  Aarau - White',
    city: 'aarau',
    category: ['darkBg', 'square'],
    downloadLinks: {
      eps: '/de/media/smzh-aarau/Icon/White/Icon - Aarau - White.eps',
      svg: '/de/media/smzh-aarau/Icon/White/Icon - Aarau - White.svg',
      png: '/de/media/smzh-aarau/Icon/White/Icon - Aarau - White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-aarau/Full Logo/White/Full-Logo---Aarau---White.png',
    alt: 'SMZH Logo Badge -  Basel - White',
    title: 'SMZH Logo Badge -  Basel - White',
    city: 'aarau',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh-aarau/Full Logo/White/Full-Logo---Aarau---White.eps',
      svg: '/de/media/smzh-aarau/Full Logo/White/Full-Logo---Aarau---White.svg',
      png: '/de/media/smzh-aarau/Full Logo/White/Full-Logo---Aarau---White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-aarau/Badges/Logo Badge/White/Logo-Badge---Aarau---White.png',
    alt: 'SMZH Logo Badge -  Aarau - Blue',
    title: 'SMZH Logo Badge -  Aarau - Blue',
    city: 'aarau',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh-aarau/Badges/Logo Badge/White/Logo-Badge---Aarau---White.eps',
      svg: '/de/media/smzh-aarau/Badges/Logo Badge/White/Logo-Badge---Aarau---White.svg',
      png: '/de/media/smzh-aarau/Badges/Logo Badge/White/Logo-Badge---Aarau---White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-aarau/Badges/Icon Badge/Blue/Icon-Badge---Aarau---Blue.png',
    alt: 'SMZH Icon Badge -  Aarau - Blue',
    title: 'SMZH Icon Badge -  Aarau - Blue',
    city: 'aarau',
    category: 'square',
    downloadLinks: {
      eps: '/de/media/smzh-aarau/Badges/Icon Badge/Blue/Icon-Badge---Aarau---Blue.eps',
      svg: '/de/media/smzh-aarau/Badges/Icon Badge/Blue/Icon-Badge---Aarau---Blue.svg',
      png: '/de/media/smzh-aarau/Badges/Icon Badge/Blue/Icon-Badge---Aarau---Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-aarau/Badges/Icon Badge/White/Icon-Badge---Aarau---White.png',
    alt: 'SMZH Icon Badge -  Aarau - White',
    title: 'SMZH Icon Badge -  Aarau - White',
    city: 'aarau',
    category: ['square', 'bgNeutral50'],
    downloadLinks: {
      eps: '/de/media/smzh-aarau/Badges/Icon Badge/White/Icon-Badge---Aarau---White.eps',
      svg: '/de/media/smzh-aarau/Badges/Icon Badge/White/Icon-Badge---Aarau---White.svg',
      png: '/de/media/smzh-aarau/Badges/Icon Badge/White/Icon-Badge---Aarau---White.png',
    },
  },

  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-arosa/Icon/Blue/Icon - Arosa - Blue.png',
    alt: 'SMZH Icon -  Arosa - Blue',
    title: 'SMZH Icon -  Arosa - Blue',
    city: 'arosa',
    category: 'square',
    downloadLinks: {
      eps: '/de/media/smzh-aarau/Icon/Blue/Icon - Arosa - Blue.eps',
      svg: '/de/media/smzh-aarau/Icon/Blue/Icon - Arosa - Blue.svg',
      png: '/de/media/smzh-aarau/Icon/Blue/Icon - Arosa - Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-arosa/Full Logo/Blue/Full Logo - Arosa - Blue.png',
    alt: 'SMZH Logo -  Arosa - Blue',
    title: 'SMZH Logo -  Arosa - Blue',
    city: 'arosa',
    downloadLinks: {
      eps: '/de/media/smzh-arosa/Full Logo/Blue/Full Logo - Arosa - Blue.eps',
      svg: '/de/media/smzh-arosa/Full Logo/Blue/Full Logo - Arosa - Blue.svg',
      png: '/de/media/smzh-arosa/Full Logo/Blue/Full Logo - Arosa - Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-arosa/Badges/Logo Badge/Blue/Logo-Badge---Aarau---Blue.png',
    alt: 'SMZH Logo -  Arosa - Blue',
    title: 'SMZH Logo -  Arosa - Blue',
    city: 'arosa',
    downloadLinks: {
      eps: '/de/media/smzh-arosa/Badges/Logo Badge/Blue/Logo Badge - Aarau - Blue.eps',
      svg: '/de/media/smzh-arosa/Badges/Logo Badge/Blue/Logo Badge - Aarau - Blue.svg',
      png: '/de/media/smzh-arosa/Badges/Logo Badge/Blue/Logo-Badge---Aarau---Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-arosa/Icon/White/Icon - Arosa - White.png',
    alt: 'SMZH Icon -  Arosa - White',
    title: 'SMZH Icon -  Arosa - White',
    city: 'arosa',
    category: ['darkBg', 'square'],
    downloadLinks: {
      eps: '/de/media/smzh-arosa/Icon/White/Icon - Arosa - White.eps',
      svg: '/de/media/smzh-arosa/Icon/White/Icon - Arosa - White.svg',
      png: '/de/media/smzh-arosa/Icon/White/Icon - Arosa - White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-arosa/Full Logo/White/Full Logo - Arosa - White.png',
    alt: 'SMZH Logo Badge -  Arosa - White',
    title: 'SMZH Logo Badge -  Arosa - White',
    city: 'arosa',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh-arosa/Full Logo/White/Full Logo - Arosa - White.eps',
      svg: '/de/media/smzh-arosa/Full Logo/White/Full Logo - Arosa - White.svg',
      png: '/de/media/smzh-arosa/Full Logo/White/Full Logo - Arosa - White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-arosa/Badges/Logo Badge/White/Logo-Badge---Aarau---White.png',
    alt: 'SMZH Logo Badge -  Arosa - Blue',
    title: 'SMZH Logo Badge -  Arosa - Blue',
    city: 'arosa',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh-arosa/Badges/Logo Badge/White/Logo Badge - Aarau - White.eps',
      svg: '/de/media/smzh-arosa/Badges/Logo Badge/White/Logo Badge - Aarau - White.svg',
      png: '/de/media/smzh-arosa/Badges/Logo Badge/White/Logo-Badge---Aarau---White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-arosa/Badges/Icon Badge/Blue/Icon-Badge---Arosa---Blue.png',
    alt: 'SMZH Icon Badge -  Arosa - Blue',
    title: 'SMZH Icon Badge -  Arosa - Blue',
    city: 'arosa',
    category: 'square',
    downloadLinks: {
      eps: '/de/media/smzh-arosa/Badges/Icon Badge/Blue/Icon Badge - Arosa - Blue.eps',
      svg: '/de/media/smzh-arosa/Badges/Icon Badge/Blue/Icon Badge - Arosa - Blue.svg',
      png: '/de/media/smzh-arosa/Badges/Icon Badge/Blue/Icon-Badge---Arosa---Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-arosa/Badges/Icon Badge/White/Icon-Badge---Arosa---White.png',
    alt: 'SMZH Icon Badge -  Arosa - White',
    title: 'SMZH Icon Badge -  Arosa - White',
    city: 'arosa',
    category: ['square', 'bgNeutral50'],
    downloadLinks: {
      eps: '/de/media/smzh-arosa/Badges/Icon Badge/White/Icon Badge - Arosa - White.eps',
      svg: '/de/media/smzh-arosa/Badges/Icon Badge/White/Icon Badge - Arosa - White.svg',
      png: '/de/media/smzh-arosa/Badges/Icon Badge/White/Icon-Badge---Arosa---White.png',
    },
  },

  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-basel/Icon/Blue/Icon - Basel - Blue.png',
    alt: 'SMZH Icon -  Basel - Blue',
    title: 'SMZH Icon -  Basel - Blue',
    city: 'basel',
    category: 'square',
    downloadLinks: {
      eps: '/de/media/smzh-basel/Icon/Blue/Icon - Basel - Blue.eps',
      svg: '/de/media/smzh-basel/Icon/Blue/Icon - Basel - Blue.svg',
      png: '/de/media/smzh-basel/Icon/Blue/Icon - Basel - Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-basel/Full Logo/Blue/Logo Badge - Basel - White.png',
    alt: 'SMZH Logo -  Basel - Blue',
    title: 'SMZH Logo -  Basel - Blue',
    city: 'basel',
    downloadLinks: {
      eps: '/de/media/smzh-basel/Full Logo/Blue/Logo Badge - Basel - White.eps',
      svg: '/de/media/smzh-basel/Full Logo/Blue/Logo Badge - Basel - White.svg',
      png: '/de/media/smzh-basel/Full Logo/Blue/Logo Badge - Basel - White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-basel/Badges/Logo Badge/Blue/Logo Badge - Basel - Blue.png',
    alt: 'SMZH Logo -  Basel - Blue',
    title: 'SMZH Logo -  Basel - Blue',
    city: 'basel',
    downloadLinks: {
      eps: '/de/media/smzh-basel/Badges/Logo Badge/Blue/Logo Badge - Basel - Blue.eps',
      svg: '/de/media/smzh-basel/Badges/Logo Badge/Blue/Logo Badge - Basel - Blue.svg',
      png: '/de/media/smzh-basel/Badges/Logo Badge/Blue/Logo Badge - Basel - Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-basel/Icon/White/Icon - Basel - White.png',
    alt: 'SMZH Icon -  Basel - White',
    title: 'SMZH Icon -  Basel - White',
    city: 'basel',
    category: ['darkBg', 'square'],
    downloadLinks: {
      eps: '/de/media/smzh-basel/Icon/White/Icon - Basel - White.eps',
      svg: '/de/media/smzh-basel/Icon/White/Icon - Basel - White.svg',
      png: '/de/media/smzh-basel/Icon/White/Icon - Basel - White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-basel/Full Logo/White/Full Logo - Basel - White.png',
    alt: 'SMZH Logo Badge -  Basel - White',
    title: 'SMZH Logo Badge -  Basel - White',
    city: 'basel',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh-basel/Full Logo/White/Full Logo - Basel - White.eps',
      svg: '/de/media/smzh-basel/Full Logo/White/Full Logo - Basel - White.svg',
      png: '/de/media/smzh-basel/Full Logo/White/Full Logo - Basel - White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-basel/Badges/Logo Badge/White/Logo Badge - Basel - White.png',
    alt: 'SMZH Logo Badge -  Basel - Blue',
    title: 'SMZH Logo Badge -  Basel - Blue',
    city: 'basel',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh-basel/Badges/Logo Badge/White/Logo Badge - Basel - White.eps',
      svg: '/de/media/smzh-basel/Badges/Logo Badge/White/Logo Badge - Basel - White.svg',
      png: '/de/media/smzh-basel/Badges/Logo Badge/White/Logo Badge - Basel - White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-basel/Badges/Icon Badge/Blue/Icon Badge - Basel - Blue.png',
    alt: 'SMZH Icon Badge -  Basel - Blue',
    title: 'SMZH Icon Badge -  Basel - Blue',
    city: 'basel',
    category: 'square',
    downloadLinks: {
      eps: '/de/media/smzh-basel/Badges/Icon Badge/Blue/Icon Badge - Basel - Blue.eps',
      svg: '/de/media/smzh-basel/Badges/Icon Badge/Blue/Icon Badge - Basel - Blue.svg',
      png: '/de/media/smzh-basel/Badges/Icon Badge/Blue/Icon Badge - Basel - Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-basel/Badges/Icon Badge/White/Icon Badge - Basel - White.png',
    alt: 'SMZH Icon Badge -  Arosa - White',
    title: 'SMZH Icon Badge -  Arosa - White',
    city: 'basel',
    category: ['square', 'bgNeutral50'],
    downloadLinks: {
      eps: '/de/media/smzh-basel/Badges/Icon Badge/White/Icon Badge - Basel - White.eps',
      svg: '/de/media/smzh-basel/Badges/Icon Badge/White/Icon Badge - Basel - White.svg',
      png: '/de/media/smzh-basel/Badges/Icon Badge/White/Icon Badge - Basel - White.png',
    },
  },

  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-baden/Icon/Blue/Icon---Baden---Blue.png',
    alt: 'SMZH Icon -  Baden - Blue',
    title: 'SMZH Icon -  Baden - Blue',
    city: 'baden',
    category: 'square',
    downloadLinks: {
      eps: '/de/media/smzh-baden/Icon/Blue/Icon - Baden - Blue.eps',
      svg: '/de/media/smzh-baden/Icon/Blue/Icon - Baden - Blue.svg',
      png: '/de/media/smzh-baden/Icon/Blue/Icon---Baden---Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-baden/Full Logo/Blue/Full-Logo---Baden---Blue.png',
    alt: 'SMZH Logo -  Baden - Blue',
    title: 'SMZH Logo -  Baden - Blue',
    city: 'baden',
    downloadLinks: {
      eps: '/de/media/smzh-baden/Full Logo/Blue/Full Logo - Baden - Blue.eps',
      svg: '/de/media/smzh-baden/Full Logo/Blue/Full Logo - Baden - Blue.svg',
      png: '/de/media/smzh-baden/Full Logo/Blue/Full-Logo---Baden---Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-baden/Badges/Logo Badge/Blue/Logo-Badge---Baden---Blue.png',
    alt: 'SMZH Logo -  Baden - Blue',
    title: 'SMZH Logo -  Baden - Blue',
    city: 'baden',
    downloadLinks: {
      eps: '/de/media/smzh-baden/Badges/Logo Badge/Blue/Logo Badge - Baden - Blue.eps',
      svg: '/de/media/smzh-baden/Badges/Logo Badge/Blue/Logo Badge - Baden - Blue.svg',
      png: '/de/media/smzh-baden/Badges/Logo Badge/Blue/Logo-Badge---Baden---Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-baden/Icon/White/Icon---Baden---White.png',
    alt: 'SMZH Icon -  Baden - White',
    title: 'SMZH Icon -  Baden - White',
    city: 'baden',
    category: ['darkBg', 'square'],
    downloadLinks: {
      eps: '/de/media/smzh-baden/Icon/White/Icon - Baden - White.eps',
      svg: '/de/media/smzh-baden/Icon/White/Icon - Baden - White.svg',
      png: '/de/media/smzh-baden/Icon/White/Icon---Baden---White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-baden/Full Logo/White/Full-Logo---Baden---White.png',
    alt: 'SMZH Logo Badge -  Baden - White',
    title: 'SMZH Logo Badge -  Baden - White',
    city: 'baden',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh-baden/Full Logo/White/Full-Logo---Baden---White.eps',
      svg: '/de/media/smzh-baden/Full Logo/White/Full Logo - Baden - White.svg',
      png: '/de/media/smzh-baden/Full Logo/White/Full-Logo---Baden---White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-baden/Badges/Logo Badge/White/Logo-Badge---Baden---White.png',
    alt: 'SMZH Logo Badge -  Baden - Blue',
    title: 'SMZH Logo Badge -  Baden - Blue',
    city: 'baden',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh-baden/Badges/Logo Badge/White/Logo Badge - Baden - White.eps',
      svg: '/de/media/smzh-baden/Badges/Logo Badge/White/Logo Badge - Baden - White.svg',
      png: '/de/media/smzh-baden/Badges/Logo Badge/White/Logo-Badge---Baden---White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-baden/Badges/Icon Badge/Blue/Icon-Badge---Baden---Blue.png',
    alt: 'SMZH Icon Badge -  Baden - Blue',
    title: 'SMZH Icon Badge -  Baden - Blue',
    city: 'baden',
    category: 'square',
    downloadLinks: {
      eps: '/de/media/smzh-baden/Badges/Icon Badge/Blue/Icon Badge - Baden - Blue.eps',
      svg: '/de/media/smzh-baden/Badges/Icon Badge/Blue/Icon Badge - Baden - Blue.svg',
      png: '/de/media/smzh-baden/Badges/Icon Badge/Blue/Icon-Badge---Baden---Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-baden/Badges/Icon Badge/White/Icon-Badge---Baden---White.png',
    alt: 'SMZH Icon Badge -  Baden - White',
    title: 'SMZH Icon Badge -  Baden - White',
    city: 'baden',
    category: ['square', 'bgNeutral50'],
    downloadLinks: {
      eps: '/de/media/smzh-baden/Badges/Icon Badge/White/Icon Badge - Baden - White.eps',
      svg: '/de/media/smzh-baden/Badges/Icon Badge/White/Icon Badge - Baden - White.svg',
      png: '/de/media/smzh-baden/Badges/Icon Badge/White/Icon-Badge---Baden---White.png',
    },
  },

  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-bern/Icon/Blue/Icon - Bern - Blue.png',
    alt: 'SMZH Icon -  Bern - Blue',
    title: 'SMZH Icon -  Bern - Blue',
    city: 'bern',
    category: 'square',
    downloadLinks: {
      eps: '/de/media/smzh-bern/Icon/Blue/Icon - Bern - Blue.eps',
      svg: '/de/media/smzh-bern/Icon/Blue/Icon - Bern - Blue.svg',
      png: '/de/media/smzh-bern/Icon/Blue/Icon - Bern - Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-bern/Full Logo/Blue/Full Logo - Bern - Blue.png',
    alt: 'SMZH Logo -  Bern - Blue',
    title: 'SMZH Logo -  Bern - Blue',
    city: 'bern',
    downloadLinks: {
      eps: '/de/media/smzh-bern/Full Logo/Blue/Full Logo - Bern - Blue.eps',
      svg: '/de/media/smzh-bern/Full Logo/Blue/Full Logo - Bern - Blue.svg',
      png: '/de/media/smzh-bern/Full Logo/Blue/Full Logo - Bern - Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-bern/Badges/Logo Badge/Blue/Logo-Badge---Bern---Blue.png',
    alt: 'SMZH Logo -  Bern - Blue',
    title: 'SMZH Logo -  Bern - Blue',
    city: 'bern',
    downloadLinks: {
      eps: '/de/media/smzh-bern/Badges/Logo Badge/Blue/Logo Badge - Bern - Blue.eps',
      svg: '/de/media/smzh-bern/Badges/Logo Badge/Blue/Logo Badge - Bern - Blue.svg',
      png: '/de/media/smzh-bern/Badges/Logo Badge/Blue/Logo-Badge---Bern---Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-bern/Icon/White/Icon - Bern - White.png',
    alt: 'SMZH Icon -  Bern - White',
    title: 'SMZH Icon -  Bern - White',
    city: 'bern',
    category: ['darkBg', 'square'],
    downloadLinks: {
      eps: '/de/media/smzh-bern/Icon/White/Icon - Bern - White.eps',
      svg: '/de/media/smzh-bern/Icon/White/Icon - Bern - White.svg',
      png: '/de/media/smzh-bern/Icon/White/Icon - Bern - White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-bern/Full Logo/White/Full Logo - Bern - White.png',
    alt: 'SMZH Logo Badge -  Bern - White',
    title: 'SMZH Logo Badge -  Bern - White',
    city: 'bern',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh-bern/Full Logo/White/Full Logo - Bern - White.eps',
      svg: '/de/media/smzh-bern/Full Logo/White/Full Logo - Bern - White.svg',
      png: '/de/media/smzh-bern/Full Logo/White/Full Logo - Bern - White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-bern/Badges/Logo Badge/White/Logo-Badge---Bern---White.png',
    alt: 'SMZH Logo Badge -  Basel - Blue',
    title: 'SMZH Logo Badge -  Basel - Blue',
    city: 'bern',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh-bern/Badges/Logo Badge/White/Logo Badge - Bern - White.eps',
      svg: '/de/media/smzh-bern/Badges/Logo Badge/White/Logo Badge - Bern - White.svg',
      png: '/de/media/smzh-bern/Badges/Logo Badge/White/Logo-Badge---Bern---White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-bern/Badges/Icon Badge/Blue/Icon-Badge---Bern---Blue.png',
    alt: 'SMZH Icon Badge -  Basel - Blue',
    title: 'SMZH Icon Badge -  Basel - Blue',
    city: 'bern',
    category: 'square',
    downloadLinks: {
      eps: 'public/de/media/smzh-bern/Badges/Icon Badge/Blue/Icon Badge - Bern - Blue.eps',
      svg: '/de/media/smzh-bern/Badges/Icon Badge/Blue/Icon Badge - Bern - Blue.svg',
      png: '/de/media/smzh-bern/Badges/Icon Badge/Blue/Icon-Badge---Bern---Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-bern/Badges/Icon Badge/White/Icon-Badge---Bern---White.png',
    alt: 'SMZH Icon Badge -  Arosa - White',
    title: 'SMZH Icon Badge -  Arosa - White',
    city: 'bern',
    category: ['square', 'bgNeutral50'],
    downloadLinks: {
      eps: '/de/media/smzh-bern/Badges/Icon Badge/White/Icon Badge - Bern - White.eps',
      svg: '/de/media/smzh-bern/Badges/Icon Badge/White/Icon Badge - Bern - White.svg',
      png: '/de/media/smzh-bern/Badges/Icon Badge/White/Icon-Badge---Bern---White.png',
    },
  },

  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-buchs/Icon/Blue/Icon - Buchs SG - Blue.png',
    alt: 'SMZH Icon -  Buchs - Blue',
    title: 'SMZH Icon -  Buchs - Blue',
    city: 'buchs',
    category: 'square',
    downloadLinks: {
      eps: '/de/media/smzh-buchs/Icon/Blue/Icon - Buchs SG - Blue.eps',
      svg: '/de/media/smzh-buchs/Icon/Blue/Icon - Buchs SG - Blue.svg',
      png: '/de/media/smzh-buchs/Icon/Blue/Icon - Buchs SG - Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-buchs/Full Logo/Blue/Full logo - Buchs SG - Blue.png',
    alt: 'SMZH Logo -  Buchs - Blue',
    title: 'SMZH Logo -  Buchs - Blue',
    city: 'buchs',
    downloadLinks: {
      eps: '/de/media/smzh-buchs/Full Logo/Blue/Full logo - Buchs SG - Blue.eps',
      svg: '/de/media/smzh-buchs/Full Logo/Blue/Full logo - Buchs SG - Blue.svg',
      png: '/de/media/smzh-buchs/Full Logo/Blue/Full logo - Buchs SG - Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-buchs/Badges/Logo Badge/Blue/Logo-Badge---Buchs---Blue.png',
    alt: 'SMZH Logo -  Buchs - Blue',
    title: 'SMZH Logo -  Buchs - Blue',
    city: 'buchs',
    downloadLinks: {
      eps: '/de/media/smzh-buchs/Badges/Logo Badge/Blue/Logo Badge - Buchs - Blue.eps',
      svg: '/de/media/smzh-buchs/Badges/Logo Badge/Blue/Logo Badge - Buchs - Blue.svg',
      png: '/de/media/smzh-buchs/Badges/Logo Badge/Blue/Logo-Badge---Buchs---Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-buchs/Icon/White/Icon - Buchs SG - White.png',
    alt: 'SMZH Icon -  Buchs - White',
    title: 'SMZH Icon -  Buchs - White',
    city: 'buchs',
    category: ['darkBg', 'square'],
    downloadLinks: {
      eps: '/de/media/smzh-buchs/Icon/White/Icon - Buchs SG - White.eps',
      svg: '/de/media/smzh-buchs/Icon/White/Icon - Buchs SG - White.svg',
      png: '/de/media/smzh-buchs/Icon/White/Icon - Buchs SG - White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-buchs/Full Logo/White/Full Logo - Buchs SG - White.png',
    alt: 'SMZH Logo Badge -  Buchs - White',
    title: 'SMZH Logo Badge -  Buchs - White',
    city: 'buchs',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh-buchs/Full Logo/White/Full Logo - Buchs SG - White.eps',
      svg: '/de/media/smzh-buchs/Full Logo/White/Full Logo - Buchs SG - White.svg',
      png: '/de/media/smzh-buchs/Full Logo/White/Full Logo - Buchs SG - White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-buchs/Badges/Logo Badge/White/Logo-Badge---Bern---White.png',
    alt: 'SMZH Logo Badge -  Buchs - Blue',
    title: 'SMZH Logo Badge -  Buchs - Blue',
    city: 'buchs',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh-buchs/Badges/Logo Badge/White/Logo Badge - Bern - White.eps',
      svg: '/de/media/smzh-buchs/Badges/Logo Badge/White/Logo Badge - Bern - White.svg',
      png: '/de/media/smzh-buchs/Badges/Logo Badge/White/Logo-Badge---Bern---White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-buchs/Badges/Icon Badge/Blue/Icon-Badge---Buchs--Blue.png',
    alt: 'SMZH Icon Badge -  Buchs - Blue',
    title: 'SMZH Icon Badge -  Buchs - Blue',
    city: 'buchs',
    category: 'square',
    downloadLinks: {
      eps: '/de/media/smzh-buchs/Badges/Icon Badge/Blue/Icon Badge - Buchs- Blue.eps',
      svg: '/de/media/smzh-buchs/Badges/Icon Badge/Blue/Icon Badge - Buchs- Blue.svg',
      png: '/de/media/smzh-buchs/Badges/Icon Badge/Blue/Icon-Badge---Buchs--Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-buchs/Badges/Icon Badge/White/Icon-Badge---Buchs---White.png',
    alt: 'SMZH Icon Badge -  Buchs - White',
    title: 'SMZH Icon Badge -  Buchs - White',
    city: 'buchs',
    category: ['square', 'bgNeutral50'],
    downloadLinks: {
      eps: '/de/media/smzh-buchs/Badges/Icon Badge/White/Icon Badge - Buchs - White.eps',
      svg: '/de/media/smzh-buchs/Badges/Icon Badge/White/Icon Badge - Buchs - White.svg',
      png: '/de/media/smzh-buchs/Badges/Icon Badge/White/Icon-Badge---Buchs---White.png',
    },
  },

  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-chur/Icon/Blue/Icon---Chur---Blue.png',
    alt: 'SMZH Icon -  Chur - Blue',
    title: 'SMZH Icon -  Chur - Blue',
    city: 'chur',
    category: 'square',
    downloadLinks: {
      eps: '/de/media/smzh-chur/Icon/Blue/Icon - Chur - Blue.eps',
      svg: '/de/media/smzh-chur/Icon/Blue/Icon - Chur - Blue.svg',
      png: '/de/media/smzh-chur/Icon/Blue/Icon---Chur---Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-chur/Full Logo/Blue/Full-Logo---Chur---Blue.png',
    alt: 'SMZH Logo -  Chur - Blue',
    title: 'SMZH Logo -  Chur - Blue',
    city: 'chur',
    downloadLinks: {
      eps: 'de/media/smzh-chur/Full Logo/Blue/Full Logo - Chur - Blue.eps',
      svg: '/de/media/smzh-chur/Full Logo/Blue/Full Logo - Chur - Blue.svg',
      png: '/de/media/smzh-chur/Full Logo/Blue/Full-Logo---Chur---Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-chur/Badges/Logo Badge/Blue/Logo-Badge---Chur---Blue.png',
    alt: 'SMZH Logo -  Chur - Blue',
    title: 'SMZH Logo -  Chur - Blue',
    city: 'chur',
    downloadLinks: {
      eps: '/de/media/smzh-chur/Badges/Logo Badge/Blue/Logo Badge - Chur - Blue.eps',
      svg: '/de/media/smzh-chur/Badges/Logo Badge/Blue/Logo Badge - Chur - Blue.svg',
      png: '/de/media/smzh-chur/Badges/Logo Badge/Blue/Logo-Badge---Chur---Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-chur/Icon/White/Icon---Chur---White.png',
    alt: 'SMZH Icon -  Chur - White',
    title: 'SMZH Icon -  Chur - White',
    city: 'chur',
    category: ['darkBg', 'square'],
    downloadLinks: {
      eps: '/de/media/smzh-chur/Icon/White/Icon - Chur - White.eps',
      svg: '/de/media/smzh-chur/Icon/White/Icon - Chur - White.svg',
      png: '/de/media/smzh-chur/Icon/White/Icon---Chur---White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-chur/Full Logo/White/Full-Logo---Chur---White.png',
    alt: 'SMZH Logo Badge -  Chur - White',
    title: 'SMZH Logo Badge -  Chur - White',
    city: 'chur',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh-chur/Full Logo/White/Full Logo - Chur - White.eps',
      svg: '/de/media/smzh-chur/Full Logo/White/Full Logo - Chur - White.svg',
      png: '/de/media/smzh-chur/Full Logo/White/Full-Logo---Chur---White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-chur/Badges/Logo Badge/White/Logo-Badge---Chur---White.png',
    alt: 'SMZH Logo Badge -  Chur - Blue',
    title: 'SMZH Logo Badge -  Chur - Blue',
    city: 'chur',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh-chur/Badges/Logo Badge/White/Logo Badge - Chur - White.eps',
      svg: '/de/media/smzh-chur/Badges/Logo Badge/White/Logo Badge - Chur - White.svg',
      png: '/de/media/smzh-chur/Badges/Logo Badge/White/Logo-Badge---Chur---White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-chur/Badges/Icon Badge/Blue/Icon-Badge---Chur---Blue.png',
    alt: 'SMZH Icon Badge -  Chur - Blue',
    title: 'SMZH Icon Badge -  Chur - Blue',
    city: 'chur',
    category: 'square',
    downloadLinks: {
      eps: '/de/media/smzh-chur/Badges/Icon Badge/Blue/Icon Badge - Chur - Blue.eps',
      svg: '/de/media/smzh-chur/Badges/Icon Badge/Blue/Icon Badge - Chur - Blue.svg',
      png: '/de/media/smzh-chur/Badges/Icon Badge/Blue/Icon-Badge---Chur---Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-chur/Badges/Icon Badge/White/Icon-Badge---Chur---White.png',
    alt: 'SMZH Icon Badge -  Chur - White',
    title: 'SMZH Icon Badge -  Chur - White',
    city: 'chur',
    category: ['square', 'bgNeutral50'],
    downloadLinks: {
      eps: '/de/media/smzh-chur/Badges/Icon Badge/White/Icon Badge - Chur - White.eps',
      svg: '/de/media/smzh-chur/Badges/Icon Badge/White/Icon Badge - Chur - White.svg',
      png: '/de/media/smzh-chur/Badges/Icon Badge/White/Icon-Badge---Chur---White.png',
    },
  },

  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-frauenfeld/Icon/Blue/Icon - Frauenfeld - Blue.png',
    alt: 'SMZH Icon -  Frauenfeld - Blue',
    title: 'SMZH Icon -  Frauenfeld - Blue',
    city: 'frauenfeld',
    category: 'square',
    downloadLinks: {
      eps: '/de/media/smzh-frauenfeld/Icon/Blue/Icon - Frauenfeld - Blue.eps',
      svg: '/de/media/smzh-frauenfeld/Icon/Blue/Icon - Frauenfeld - Blue.svg',
      png: '/de/media/smzh-frauenfeld/Icon/Blue/Icon - Frauenfeld - Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-frauenfeld/Full Logo/Blue/Full Logo - Frauenfeld - Blue.png',
    alt: 'SMZH Logo -  Chur - Blue',
    title: 'SMZH Logo -  Chur - Blue',
    city: 'frauenfeld',
    downloadLinks: {
      eps: '/de/media/smzh-frauenfeld/Full Logo/Blue/Full Logo - Frauenfeld - Blue.eps',
      svg: '/de/media/smzh-frauenfeld/Full Logo/Blue/Full Logo - Frauenfeld - Blue.svg',
      png: '/de/media/smzh-frauenfeld/Full Logo/Blue/Full Logo - Frauenfeld - Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-frauenfeld/Badges/Logo Badge/Blue/Badge - Frauenfeld - Blue.png',
    alt: 'SMZH Logo -  Frauenfeld - Blue',
    title: 'SMZH Logo -  Frauenfeld - Blue',
    city: 'frauenfeld',
    downloadLinks: {
      eps: '/de/media/smzh-frauenfeld/Badges/Logo Badge/Blue/Logo Badge - Frauenfeld - Blue.eps',
      svg: '/de/media/smzh-frauenfeld/Badges/Logo Badge/Blue/Logo Badge - Frauenfeld - Blue.svg',
      png: '/de/media/smzh-frauenfeld/Badges/Logo Badge/Blue/Badge - Frauenfeld - Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-frauenfeld/Icon/White/Icon - Frauenfeld - White.png',
    alt: 'SMZH Icon -  Frauenfeld - White',
    title: 'SMZH Icon -  Frauenfeld - White',
    city: 'frauenfeld',
    category: ['darkBg', 'square'],
    downloadLinks: {
      eps: '/de/media/smzh-frauenfeld/Icon/White/Icon - Frauenfeld - White.eps',
      svg: '/de/media/smzh-frauenfeld/Icon/White/Icon - Frauenfeld - White.svg',
      png: '/de/media/smzh-frauenfeld/Icon/White/Icon - Frauenfeld - White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-frauenfeld/Full Logo/White/Full Logo - Frauenfeld - White.png',
    alt: 'SMZH Logo Badge -  Frauenfeld - White',
    title: 'SMZH Logo Badge -  Frauenfeld - White',
    city: 'frauenfeld',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh-frauenfeld/Full Logo/White/Full Logo -Fraunfeld - White.eps',
      svg: '/de/media/smzh-frauenfeld/Full Logo/White/Full Logo - Frauenfeld - White.svg',
      png: '/de/media/smzh-frauenfeld/Full Logo/White/Full Logo - Frauenfeld - White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-frauenfeld/Badges/Logo Badge/White/Badge - Frauenfeld - White.png',
    alt: 'SMZH Logo Badge -  Frauenfeld - Blue',
    title: 'SMZH Logo Badge -  Frauenfeld - Blue',
    city: 'frauenfeld',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh-frauenfeld/Badges/Logo Badge/White/Logo Badge - Frauenfeld - White.eps',
      svg: '/de/media/smzh-frauenfeld/Badges/Logo Badge/White/Logo Badge - Frauenfeld - White.svg',
      png: '/de/media/smzh-frauenfeld/Badges/Logo Badge/White/Badge - Frauenfeld - White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-frauenfeld/Badges/Icon Badge/Blue/Icon Badge - Frauenfeld - Blue.png',
    alt: 'SMZH Icon Badge -  Frauenfeld - Blue',
    title: 'SMZH Icon Badge -  Frauenfeld - Blue',
    city: 'frauenfeld',
    category: 'square',
    downloadLinks: {
      eps: '/de/media/smzh-frauenfeld/Badges/Icon Badge/Blue/Icon Badge - Frauenfeld - Blue.eps',
      svg: '/de/media/smzh-frauenfeld/Badges/Icon Badge/Blue/Icon Badge - Frauenfeld - Blue.svg',
      png: '/de/media/smzh-frauenfeld/Badges/Icon Badge/Blue/Icon Badge - Frauenfeld - Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-frauenfeld/Badges/Icon Badge/White/Icon Badge - Frauenfeld - White.png',
    alt: 'SMZH Icon Badge -  Frauenfeld - White',
    title: 'SMZH Icon Badge -  Frauenfeld - White',
    city: 'frauenfeld',
    category: ['square', 'bgNeutral50'],
    downloadLinks: {
      eps: '/de/media/smzh-frauenfeld/Badges/Icon Badge/White/Icon Badge - Frauenfeld - White.eps',
      svg: '/de/media/smzh-frauenfeld/Badges/Icon Badge/White/Icon Badge - Frauenfeld - White.svg',
      png: '/de/media/smzh-frauenfeld/Badges/Icon Badge/White/Icon Badge - Frauenfeld - White.png',
    },
  },

  {
    variant: 'logoCardImage',
    src: '/de/media/smzh_stgallen/Icon/Blue/Icon - StGallen - Blue.png',
    alt: 'SMZH Icon -  StGallen - Blue',
    title: 'SMZH Icon -  StGallen - Blue',
    city: 'stgallen',
    category: 'square',
    downloadLinks: {
      eps: '/de/media/smzh_stgallen/Icon/Blue/Icon - StGallen - Blue.eps',
      svg: '/de/media/smzh_stgallen/Icon/Blue/Icon - StGallen - Blue.svg',
      png: '/de/media/smzh_stgallen/Icon/Blue/Icon - StGallen - Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh_stgallen/Full Logo/Blue/Full Logo - StGallen - Blue.png',
    alt: 'SMZH Logo -  StGallen - Blue',
    title: 'SMZH Logo -  StGallen - Blue',
    city: 'stgallen',
    downloadLinks: {
      eps: '/de/media/smzh_stgallen/Full Logo/Blue/Full Logo - StGallen - Blue.eps',
      svg: '/de/media/smzh_stgallen/Full Logo/Blue/Full Logo - StGallen - Blue.svg',
      png: '/de/media/smzh_stgallen/Full Logo/Blue/Full Logo - StGallen - Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh_stgallen/Badges/Logo Badge/Blue/Logo Badge - StGallen - Blue.png',
    alt: 'SMZH Logo -  StGallen - Blue',
    title: 'SMZH Logo -  StGallen - Blue',
    city: 'stgallen',
    downloadLinks: {
      eps: '/de/media/smzh_stgallen/Badges/Logo Badge/Blue/Logo Badge - StGallen - Blue.eps',
      svg: '/de/media/smzh_stgallen/Badges/Logo Badge/Blue/Logo Badge - StGallen - Blue.svg',
      png: '/de/media/smzh_stgallen/Badges/Logo Badge/Blue/Logo Badge - StGallen - Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh_stgallen/Icon/White/Icon - StGallen - White.png',
    alt: 'SMZH Icon -  StGallen - White',
    title: 'SMZH Icon -  StGallen - White',
    city: 'stgallen',
    category: ['darkBg', 'square'],
    downloadLinks: {
      eps: '/de/media/smzh_stgallen/Icon/White/Icon - StGallen - White.eps',
      svg: '/de/media/smzh_stgallen/Icon/White/Icon - StGallen - White.svg',
      png: '/de/media/smzh_stgallen/Icon/White/Icon - StGallen - White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh_stgallen/Full Logo/White/Full Logo - StGallen - White.png',
    alt: 'SMZH Logo Badge -  StGallen - White',
    title: 'SMZH Logo Badge -  StGallen - White',
    city: 'stgallen',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh_stgallen/Full Logo/White/Full Logo - StGallen - White.eps',
      svg: '/de/media/smzh_stgallen/Full Logo/White/Full Logo - StGallen - White.svg',
      png: '/de/media/smzh_stgallen/Full Logo/White/Full Logo - StGallen - White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh_stgallen/Badges/Logo Badge/White/Logo Badge - StGallen - White.png',
    alt: 'SMZH Logo Badge -  StGallen - Blue',
    title: 'SMZH Logo Badge -  StGallen - Blue',
    city: 'stgallen',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh_stgallen/Badges/Logo Badge/White/Logo Badge - StGallen - White.eps',
      svg: '/de/media/smzh_stgallen/Badges/Logo Badge/White/Logo Badge - StGallen - White.svg',
      png: '/de/media/smzh_stgallen/Badges/Logo Badge/White/Logo Badge - StGallen - White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh_stgallen/Badges/Icon Badge/Blue/Icon Badge - StGallen - Blue.png',
    alt: 'SMZH Icon Badge -  StGallen - Blue',
    title: 'SMZH Icon Badge -  StGallen - Blue',
    city: 'stgallen',
    category: 'square',
    downloadLinks: {
      eps: '/de/media/smzh_stgallen/Badges/Icon Badge/Blue/Icon Badge - StGallen - Blue.eps',
      svg: '/de/media/smzh_stgallen/Badges/Icon Badge/Blue/Icon Badge - StGallen - Blue.svg',
      png: '/de/media/smzh_stgallen/Badges/Icon Badge/Blue/Icon Badge - StGallen - Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh_stgallen/Badges/Icon Badge/White/Icon Badge - StGallen - White.png',
    alt: 'SMZH Icon Badge -  StGallen - White',
    title: 'SMZH Icon Badge -  StGallen - White',
    city: 'stgallen',
    category: ['square', 'bgNeutral50'],
    downloadLinks: {
      eps: '/de/media/smzh_stgallen/Badges/Icon Badge/White/Icon Badge - StGallen - White.eps',
      svg: '/de/media/smzh_stgallen/Badges/Icon Badge/White/Icon Badge - StGallen - White.svg',
      png: '/de/media/smzh_stgallen/Badges/Icon Badge/White/Icon Badge - StGallen - White.png',
    },
  },

  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-luzern/Icon/Blue/Icon - Luzern - Blue.png',
    alt: 'SMZH Icon -  Luzern - Blue',
    title: 'SMZH Icon -  Luzern - Blue',
    city: 'luzern',
    category: 'square',
    downloadLinks: {
      eps: '/de/media/smzh-luzern/Icon/Blue/Icon - Luzern - Blue.eps',
      svg: '/de/media/smzh-luzern/Icon/Blue/Icon - Luzern - Blue.svg',
      png: '/de/media/smzh-luzern/Icon/Blue/Icon - Luzern - Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-luzern/Full Logo/Blue/Full Logo - Luzern - Blue.png',
    alt: 'SMZH Logo -  Luzern - Blue',
    title: 'SMZH Logo -  Luzern - Blue',
    city: 'luzern',
    downloadLinks: {
      eps: '/de/media/smzh-luzern/Full Logo/Blue/Full Logo - Luzern - Blue.eps',
      svg: '/de/media/smzh_stgallen/Full Logo/Blue/Full Logo - StGallen - Blue.svg',
      png: '/de/media/smzh-luzern/Full Logo/Blue/Full Logo - Luzern - Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-luzern/Badges/Logo Badge/Blue/Logo-Badge---Luzern---Blue.png',
    alt: 'SMZH Logo -  Luzern - Blue',
    title: 'SMZH Logo -  Luzern - Blue',
    city: 'luzern',
    downloadLinks: {
      eps: '/de/media/smzh-luzern/Badges/Logo Badge/Blue/Logo Badge - Luzern - Blue.eps',
      svg: '/de/media/smzh-luzern/Badges/Logo Badge/Blue/Logo Badge - Luzern - Blue.svg',
      png: '/de/media/smzh-luzern/Badges/Logo Badge/Blue/Logo-Badge---Luzern---Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-luzern/Icon/White/Icon - Luzern - White.png',
    alt: 'SMZH Icon -  Luzern - White',
    title: 'SMZH Icon -  Luzern - White',
    city: 'luzern',
    category: ['darkBg', 'square'],
    downloadLinks: {
      eps: '/de/media/smzh-luzern/Icon/White/Icon - Luzern - White.eps',
      svg: '/de/media/smzh-luzern/Icon/White/Icon - Luzern - White.svg',
      png: '/de/media/smzh-luzern/Icon/White/Icon - Luzern - White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-luzern/Full Logo/White/Full Logo - Luzern - White.png',
    alt: 'SMZH Logo Badge -  Luzern - White',
    title: 'SMZH Logo Badge -  Luzern - White',
    city: 'luzern',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh-luzern/Full Logo/White/Full Logo - Luzern - White.eps',
      svg: '/de/media/smzh-luzern/Full Logo/White/Full Logo - Luzern - White.svg',
      png: '/de/media/smzh-luzern/Full Logo/White/Full Logo - Luzern - White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-luzern/Badges/Logo Badge/White/Logo-Badge---Luzern---White.png',
    alt: 'SMZH Logo Badge -  Luzern - Blue',
    title: 'SMZH Logo Badge -  Luzern - Blue',
    city: 'luzern',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh-luzern/Badges/Logo Badge/White/Logo Badge - Luzern - White.eps',
      svg: '/de/media/smzh-luzern/Badges/Logo Badge/White/Logo Badge - Luzern - White.svg',
      png: '/de/media/smzh-luzern/Badges/Logo Badge/White/Logo-Badge---Luzern---White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-luzern/Badges/Icon Badge/Blue/Icon-Badge---Luzern---Blue.png',
    alt: 'SMZH Icon Badge -  Luzern - Blue',
    title: 'SMZH Icon Badge -  Luzern - Blue',
    city: 'luzern',
    category: 'square',
    downloadLinks: {
      eps: '/de/media/smzh-luzern/Badges/Icon Badge/Blue/Icon Badge - Luzern - Blue.eps',
      svg: '/de/media/smzh-luzern/Badges/Icon Badge/Blue/Icon Badge - Luzern - Blue.svg',
      png: '/de/media/smzh-luzern/Badges/Icon Badge/Blue/Icon-Badge---Luzern---Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-luzern/Badges/Icon Badge/White/Icon-Badge---Luzern---White.png',
    alt: 'SMZH Icon Badge -  Luzern - White',
    title: 'SMZH Icon Badge -  Luzern - White',
    city: 'luzern',
    category: ['square', 'bgNeutral50'],
    downloadLinks: {
      eps: '/de/media/smzh-luzern/Badges/Icon Badge/White/Icon Badge - Luzern - White.eps',
      svg: '/de/media/smzh-luzern/Badges/Icon Badge/White/Icon Badge - Luzern - White.svg',
      png: '/de/media/smzh-luzern/Badges/Icon Badge/White/Icon-Badge---Luzern---White.png',
    },
  },

  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-pfäffikon SZ/Icon/Blue/Icon---Pfäffikon--Blue.png',
    alt: 'SMZH Icon -  Pfäffikon - Blue',
    title: 'SMZH Icon -  Pfäffikon - Blue',
    city: 'pfaffikon',
    category: 'square',
    downloadLinks: {
      eps: '/de/media/smzh-pfäffikon SZ/Icon/Blue/Icon - Pfäffikon- Blue.eps',
      svg: '/de/media/smzh-pfäffikon SZ/Icon/Blue/Icon - Pfäffikon- Blue.svg',
      png: '/de/media/smzh-pfäffikon SZ/Icon/Blue/Icon---Pfäffikon--Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-pfäffikon SZ/Full Logo/Blue/Full-Logo---Pfäffikon---Blue.png',
    alt: 'SMZH Logo -  Pfäffikon - Blue',
    title: 'SMZH Logo -  Pfäffikon - Blue',
    city: 'pfaffikon',
    downloadLinks: {
      eps: '/de/media/smzh-pfäffikon SZ/Full Logo/Blue/Full Logo - Pfäffikon - Blue.eps',
      svg: '/de/media/smzh-pfäffikon SZ/Full Logo/Blue/Full Logo - Pfäffikon - Blue.svg',
      png: '/de/media/smzh-pfäffikon SZ/Full Logo/Blue/Full-Logo---Pfäffikon---Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-pfäffikon SZ/Badges/Logo Badge/Blue/Logo-Badge---Pfäffikon---Blue.png',
    alt: 'SMZH Logo -  Pfäffikon - Blue',
    title: 'SMZH Logo -  Pfäffikon - Blue',
    city: 'pfaffikon',
    downloadLinks: {
      eps: '/de/media/smzh-pfäffikon SZ/Badges/Logo Badge/Blue/Logo Badge - Pfäffikon - Blue.eps',
      svg: '/de/media/smzh-pfäffikon SZ/Badges/Logo Badge/Blue/Logo Badge - Pfäffikon - Blue.svg',
      png: '/de/media/smzh-pfäffikon SZ/Badges/Logo Badge/Blue/Logo-Badge---Pfäffikon---Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-pfäffikon SZ/Icon/White/Icon---Pfäffikon--White.png',
    alt: 'SMZH Icon -  Pfäffikon - White',
    title: 'SMZH Icon -  Pfäffikon - White',
    city: 'pfaffikon',
    category: ['darkBg', 'square'],
    downloadLinks: {
      eps: '/de/media/smzh-pfäffikon SZ/Icon/White/Icon - Pfäffikon- White.eps',
      svg: '/de/media/smzh-pfäffikon SZ/Icon/White/Icon - Pfäffikon- White.svg',
      png: '/de/media/smzh-pfäffikon SZ/Icon/White/Icon---Pfäffikon--White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-pfäffikon SZ/Full Logo/White/Full-Logo---Pfäffikon---White.png',
    alt: 'SMZH Logo Badge -  Pfäffikon - White',
    title: 'SMZH Logo Badge -  Pfäffikon - White',
    city: 'pfaffikon',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh-pfäffikon SZ/Full Logo/White/Full Logo - Pfäffikon - White.eps',
      svg: '/de/media/smzh-pfäffikon SZ/Full Logo/White/Full Logo - Pfäffikon - White.svg',
      png: '/de/media/smzh-pfäffikon SZ/Full Logo/White/Full-Logo---Pfäffikon---White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-luzern/Badges/Logo Badge/White/Logo-Badge---Luzern---White.png',
    alt: 'SMZH Logo Badge -  Pfäffikon - Blue',
    title: 'SMZH Logo Badge -  Pfäffikon - Blue',
    city: 'pfaffikon',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh-luzern/Badges/Logo Badge/White/Logo Badge - Luzern - White.eps',
      svg: '/de/media/smzh-luzern/Badges/Logo Badge/White/Logo Badge - Luzern - White.svg',
      png: '/de/media/smzh-luzern/Badges/Logo Badge/White/Logo-Badge---Luzern---White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-pfäffikon SZ/Badges/Icon Badge/Blue/Icon-Badge---Pfäffikon---Blue.png',
    alt: 'SMZH Icon Badge -  Pfäffikon - Blue',
    title: 'SMZH Icon Badge -  Pfäffikon - Blue',
    city: 'pfaffikon',
    category: 'square',
    downloadLinks: {
      eps: '/de/media/smzh-pfäffikon SZ/Badges/Icon Badge/Blue/Icon Badge - Pfäffikon - Blue.eps',
      svg: '/de/media/smzh-pfäffikon SZ/Badges/Icon Badge/Blue/Icon Badge - Pfäffikon - Blue.svg',
      png: '/de/media/smzh-pfäffikon SZ/Badges/Icon Badge/Blue/Icon-Badge---Pfäffikon---Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-pfäffikon SZ/Badges/Icon Badge/White/Icon-Badge---FPfäffikon---White.png',
    alt: 'SMZH Icon Badge -  Pfäffikon - White',
    title: 'SMZH Icon Badge -  Pfäffikon - White',
    city: 'pfaffikon',
    category: ['square', 'bgNeutral50'],
    downloadLinks: {
      eps: '/de/media/smzh-pfäffikon SZ/Badges/Icon Badge/White/Icon Badge - FPfäffikon - White.eps',
      svg: '/de/media/smzh-pfäffikon SZ/Badges/Icon Badge/White/Icon Badge - FPfäffikon - White.svg',
      png: '/de/media/smzh-pfäffikon SZ/Badges/Icon Badge/White/Icon-Badge---FPfäffikon---White.png',
    },
  },

  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-sursee/Icon/Blue/Icon---Sursee---Blue.png',
    alt: 'SMZH Icon -  Sursee - Blue',
    title: 'SMZH Icon -  Sursee - Blue',
    city: 'sursee',
    category: 'square',
    downloadLinks: {
      eps: '/de/media/smzh-sursee/Icon/Blue/Icon - Sursee - Blue.eps',
      svg: '/de/media/smzh-sursee/Icon/Blue/Icon - Sursee - Blue.svg',
      png: '/de/media/smzh-sursee/Icon/Blue/Icon---Sursee---Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-sursee/Full Logo/Blue/Full-Logo---Sursee---Blue.png',
    alt: 'SMZH Logo -  Sursee - Blue',
    title: 'SMZH Logo -  Sursee - Blue',
    city: 'sursee',
    downloadLinks: {
      eps: '/de/media/smzh-sursee/Full Logo/Blue/Full Logo - Sursee - Blue.eps',
      svg: '/de/media/smzh-sursee/Full Logo/Blue/Full Logo - Sursee - Blue.svg',
      png: '/de/media/smzh-sursee/Full Logo/Blue/Full-Logo---Sursee---Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-sursee/Badges/Logo Badge/Blue/Logo-Badge---Sursee---Blue.png',
    alt: 'SMZH Logo -  Sursee - Blue',
    title: 'SMZH Logo -  Sursee - Blue',
    city: 'sursee',
    downloadLinks: {
      eps: '/de/media/smzh-sursee/Badges/Logo Badge/Blue/Logo Badge - Sursee - Blue.eps',
      svg: '/de/media/smzh-sursee/Badges/Logo Badge/Blue/Logo Badge - Sursee - Blue.svg',
      png: '/de/media/smzh-sursee/Badges/Logo Badge/Blue/Logo-Badge---Sursee---Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-sursee/Icon/White/Icon---Sursee---White.png',
    alt: 'SMZH Icon -  Sursee - White',
    title: 'SMZH Icon -  Sursee - White',
    city: 'sursee',
    category: ['darkBg', 'square'],
    downloadLinks: {
      eps: '/de/media/smzh-sursee/Icon/White/Icon - Sursee - White.eps',
      svg: '/de/media/smzh-sursee/Icon/White/Icon - Sursee - White.svg',
      png: '/de/media/smzh-sursee/Icon/White/Icon---Sursee---White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-sursee/Full Logo/White/Full-Logo---Sursee---White.png',
    alt: 'SMZH Logo Badge -  Sursee - White',
    title: 'SMZH Logo Badge -  Sursee - White',
    city: 'sursee',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh-sursee/Full Logo/White/Full Logo - Sursee - White.eps',
      svg: '/de/media/smzh-sursee/Full Logo/White/Full Logo - Sursee - White.svg',
      png: '/de/media/smzh-sursee/Full Logo/White/Full-Logo---Sursee---White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-sursee/Badges/Logo Badge/White/Logo-Badge---Sursee---White.png',
    alt: 'SMZH Logo Badge -  Sursee - Blue',
    title: 'SMZH Logo Badge -  Sursee - Blue',
    city: 'sursee',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh-sursee/Badges/Logo Badge/White/Logo Badge - Sursee - White.eps',
      svg: '/de/media/smzh-sursee/Badges/Logo Badge/White/Logo Badge - Sursee - White.svg',
      png: '/de/media/smzh-sursee/Badges/Logo Badge/White/Logo-Badge---Sursee---White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-sursee/Badges/Icon Badge/Blue/Icon-Badge---Sursee---Blue.png',
    alt: 'SMZH Icon Badge -  Sursee - Blue',
    title: 'SMZH Icon Badge -  Sursee - Blue',
    city: 'sursee',
    category: 'square',
    downloadLinks: {
      eps: '/de/media/smzh-sursee/Badges/Icon Badge/Blue/Icon Badge - Sursee - Blue.eps',
      svg: '/de/media/smzh-sursee/Badges/Icon Badge/Blue/Icon Badge - Sursee - Blue.svg',
      png: '/de/media/smzh-sursee/Badges/Icon Badge/Blue/Icon-Badge---Sursee---Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-sursee/Badges/Icon Badge/White/Icon-Badge---Sursee---White.png',
    alt: 'SMZH Icon Badge -  Pfäffikon - White',
    title: 'SMZH Icon Badge -  Pfäffikon - White',
    city: 'sursee',
    category: ['square', 'bgNeutral50'],
    downloadLinks: {
      eps: '/de/media/smzh-sursee/Badges/Icon Badge/White/Icon Badge - Sursee - White.eps',
      svg: '/de/media/smzh-sursee/Badges/Icon Badge/White/Icon Badge - Sursee - White.svg',
      png: '/de/media/smzh-sursee/Badges/Icon Badge/White/Icon-Badge---Sursee---White.png',
    },
  },

  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-zurich/Icon/Blue/Icon - Zurich - Blue.png',
    alt: 'SMZH Icon -  Zurich - Blue',
    title: 'SMZH Icon -  Zurich - Blue',
    city: 'zurich',
    category: 'square',
    downloadLinks: {
      eps: '/de/media/smzh-zurich/Icon/Blue/Icon - Zurich - Blue.eps',
      svg: '/de/media/smzh-zurich/Icon/Blue/Icon - Zurich - Blue.svg',
      png: '/de/media/smzh-zurich/Icon/Blue/Icon - Zurich - Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-zurich/Full Logo/Blue/Full Logo - Zurich - Blue.png',
    alt: 'SMZH Logo -  Zurich - Blue',
    title: 'SMZH Logo -  Zurich - Blue',
    city: 'zurich',
    downloadLinks: {
      eps: '/de/media/smzh-zurich/Full Logo/Blue/Full Logo - Zurich - Blue.eps',
      svg: '/de/media/smzh-zurich/Full Logo/Blue/Full Logo - Zurich - Blue.svg',
      png: '/de/media/smzh-zurich/Full Logo/Blue/Full Logo - Zurich - Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-zurich/Badges/Logo Badge/Blue/Logo-Badge---Zurich---Blue.png',
    alt: 'SMZH Logo -  Zurich - Blue',
    title: 'SMZH Logo -  Zurich - Blue',
    city: 'zurich',
    downloadLinks: {
      eps: '/de/media/smzh-zurich/Badges/Logo Badge/Blue/Logo Badge - Zurich - Blue.eps',
      svg: '/de/media/smzh-zurich/Badges/Logo Badge/Blue/Logo Badge - Zurich - Blue.svg',
      png: '/de/media/smzh-zurich/Badges/Logo Badge/Blue/Logo-Badge---Zurich---Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-zurich/Icon/White/Icon - Zurich - White.png',
    alt: 'SMZH Icon -  Zurich - White',
    title: 'SMZH Icon -  Zurich - White',
    city: 'zurich',
    category: ['darkBg', 'square'],
    downloadLinks: {
      eps: '/de/media/smzh-zurich/Icon/White/Icon - Zurich - White.eps',
      svg: '/de/media/smzh-zurich/Icon/White/Icon - Zurich - White.svg',
      png: '/de/media/smzh-zurich/Icon/White/Icon - Zurich - White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-zurich/Full Logo/White/Full Logo - Zurich - White.png',
    alt: 'SMZH Logo Badge -  Zurich - White',
    title: 'SMZH Logo Badge -  Zurich - White',
    city: 'zurich',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh-zurich/Full Logo/White/Full Logo - Zurich - White.eps',
      svg: '/de/media/smzh-zurich/Full Logo/White/Full Logo - Zurich - White.svg',
      png: '/de/media/smzh-zurich/Full Logo/White/Full Logo - Zurich - White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-zurich/Badges/Logo Badge/White/Logo-Badge---Zurich---White.png',
    alt: 'SMZH Logo Badge -  Zurich - Blue',
    title: 'SMZH Logo Badge -  Zurich - Blue',
    city: 'zurich',
    category: 'darkBg',
    downloadLinks: {
      eps: '/de/media/smzh-zurich/Badges/Logo Badge/White/Logo Badge - Zurich - White.eps',
      svg: '/de/media/smzh-zurich/Badges/Logo Badge/White/Logo Badge - Zurich - White.svg',
      png: '/de/media/smzh-zurich/Badges/Logo Badge/White/Logo-Badge---Zurich---White.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-zurich/Badges/Icon Badge/Blue/Icon-Badge---Zürich---Blue.png',
    alt: 'SMZH Icon Badge -  Zurich - Blue',
    title: 'SMZH Icon Badge -  Zurich - Blue',
    city: 'zurich',
    category: 'square',
    downloadLinks: {
      eps: '/de/media/smzh-zurich/Badges/Icon Badge/Blue/Icon Badge - Zürich - Blue.eps',
      svg: '/de/media/smzh-zurich/Badges/Icon Badge/Blue/Icon Badge - Zürich - Blue.svg',
      png: '/de/media/smzh-zurich/Badges/Icon Badge/Blue/Icon-Badge---Zürich---Blue.png',
    },
  },
  {
    variant: 'logoCardImage',
    src: '/de/media/smzh-zurich/Badges/Icon Badge/White/Icon-Badge---Zürich---White.png',
    alt: 'SMZH Icon Badge -  Zurich - White',
    title: 'SMZH Icon Badge -  Zurich - White',
    city: 'zurich',
    category: ['square', 'bgNeutral50'],
    downloadLinks: {
      eps: '/de/media/smzh-zurich/Badges/Icon Badge/White/Icon Badge - Zürich - White.eps',
      svg: '/de/media/smzh-zurich/Badges/Icon Badge/White/Icon Badge - Zürich - White.svg',
      png: '/de/media/smzh-zurich/Badges/Icon Badge/White/Icon-Badge---Zürich---White.png',
    },
  },
];

const blueCards: CardProps[] = [
  {
    variant: 'logoCardImage',
    src: '/de/media/colors.png',
    title: 'SMZH Blue',
    copyBtn: true,
    category: ['noPadding', 'cover'],
    copyBtnValue: '#07314C',
  },
];

const Media: React.FC<MediaProps> = ({}) => {
  const [locationFilter, setLocationFilter] = useState('aarau');

  const filteredLocationCards = useMemo(() => {
    if (locationFilter === 'all') return locationCards;
    return locationCards.filter((card) => card.city === locationFilter);
  }, [locationFilter]);

  const downloadMediaZip = () => {
    const link = document.createElement('a');
    link.href = '/de/media.zip';
    link.download = 'smzh-media-kit.zip'; // Optional: custom file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="media-component">
      <DownloadSection
        title="smzh Media Kit"
        subtitle="Hier sind die offiziellen Logovarianten für smzh."
        button={{
          name: 'Komplettes Media Kit herunterladen ',
          variant: 'secondary',
          sizes: 'medium',
          rightIcon: { name: 'download', color: '#07314C' },
          onClick: downloadMediaZip,
        }}
      />

      <div className="mx-auto max-w-[1000px]">
        <CardWrapperGrid
          theme="light"
          spacingTop
          spacingBottom
          textAlign="center"
          gridCols={3}
          subtitle="Offizielles smzh Logo"
          subHeadline="Hier finden Sie die verschiedenen offiziellen Logos von smzh. Wählen Sie das Logo, das am besten zu Ihrem Projekt passt."
          cards={logoCards}
        />

        <CardWrapperGrid
          theme="light"
          spacingTop
          spacingBottom
          textAlign="center"
          gridCols={3}
          subtitle="smzh Badges"
          subHeadline="Verwenden Sie diese Badges zum Beispiel auf Präsentationen, Dokumenten oder Webseiten, um Ihre Verbindung zu smzh sichtbar zu machen."
          cards={badgeCards}
        />

        <CardWrapperGrid
          theme="light"
          spacingTop
          spacingBottom
          textAlign="center"
          gridCols={3}
          subtitle="Logo - nach Standort"
          subHeadline="Wählen Sie einen Standort aus und laden Sie das vollständige Logo-Kit für diesen Standort herunter."
          select={{
            label: 'Filter by Standort',
            options: [
              { label: 'Aarau', value: 'aarau' },
              { label: 'Arosa', value: 'arosa' },
              { label: 'Basel', value: 'basel' },
              { label: 'Baden', value: 'baden' },
              { label: 'Bern', value: 'bern' },
              { label: 'Buchs', value: 'buchs' },
              { label: 'Chur', value: 'chur' },
              { label: 'St. Gallen', value: 'stgallen' },
              { label: 'Sursee', value: 'sursee' },
              { label: 'Pfäffikon SZ', value: 'pfaffikon' },
              { label: 'Frauenfeld', value: 'frauenfeld' },
              { label: 'Luzern', value: 'luzern' },
              { label: 'Zurich', value: 'zurich' },
            ],
            onChange: setLocationFilter,
          }}
          cards={filteredLocationCards}
        />

        <CardWrapperGrid
          theme="light"
          spacingTop
          spacingBottom
          textAlign="center"
          gridCols={3}
          subtitle="smzh Brand Blue"
          subHeadline="Diese Werte entsprechen dem offiziellen smzh Brand Blue"
          cards={blueCards}
        />
      </div>
    </div>
  );
};

export default Media;
